import { apiClient } from './ApiClient';

export interface OAuthClient {
  id: number;
  clientId: string;
  name: string;
  description?: string;
  isActive: boolean;
  lastUsedAt?: string;
  expiresAt?: string;
  createdAt: string;
}

export interface CreateOAuthClientRequest {
  name: string;
  description?: string;
  expiresInDays?: number | null;
}

export interface CreateOAuthClientResponse {
  id: number;
  clientId: string;
  clientSecret: string; // Only returned on creation
  name: string;
  description?: string;
  isActive: boolean;
  expiresAt?: string;
  createdAt: string;
}

export const OAuthClientService = {
  /**
   * Create a new OAuth client
   */
  async create(
    data: CreateOAuthClientRequest,
  ): Promise<CreateOAuthClientResponse> {
    const response = await apiClient.post<CreateOAuthClientResponse>(
      '/oauth/clients',
      data,
    );
    return response.data;
  },

  /**
   * List all OAuth clients for the current user
   */
  async list(): Promise<OAuthClient[]> {
    const response = await apiClient.get<OAuthClient[]>('/oauth/clients');
    return response.data;
  },

  /**
   * Get a specific OAuth client by ID
   */
  async get(id: number): Promise<OAuthClient> {
    const response = await apiClient.get<OAuthClient>(`/oauth/clients/${id}`);
    return response.data;
  },

  /**
   * Revoke an OAuth client (soft delete)
   */
  async revoke(id: number): Promise<void> {
    await apiClient.patch(`/oauth/clients/${id}/revoke`);
  },

  /**
   * Delete an OAuth client permanently
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/oauth/clients/${id}`);
  },
};

